module.exports = __webpack_public_path__ + "assets/images/da05990587f840dfed3aa1a4e6c00c40.png";